import { BadgeCheck, Wrench } from 'lucide-react';

const Banner = ({ status }: { status: string }) => {
  return (
    <div
      className={
        'flex h-10 w-full flex-shrink-0 items-center justify-start px-4 ' +
        (status === 'live'
          ? 'bg-green-100/80 text-green-400'
          : 'bg-yellow-100/60 text-yellow-400')
      }
    >
      {status === 'live' ? (
        <BadgeCheck className="mr-2 h-5 w-5 text-green-400" />
      ) : (
        <Wrench className="mr-2 h-5 w-5 text-yellow-400" />
      )}
      <span className="text-lg font-medium">
        {status === 'live' ? 'Live Page' : 'Demo Page - Coming Soon'}
      </span>
    </div>
  );
};

export default Banner;
